import googleApiService from 'services/googleAPIService';

export default class MultipleChoiceOption {
  public id: string;
  public question: string;
  public text: string;
  public correct: boolean;
  public index: number;
  public img?: string;
  public img_src?: string;
  public img_file?: File;

  constructor(
    id: string,
    question: string,
    text: string,
    correct: boolean,
    index: number,
    img?: string,
    img_file?: File,
    img_src?: string,
  ) {
    this.id = id;
    this.question = question;
    this.text = text;
    this.correct = correct;
    this.index = Number(index);
    this.img = img;
    this.img_file = img_file;
    this.img_src = img_src;
  }

  public async getImageSrc() {
    if (this.img_src && this.img_src !== '') return this.img_src;
    if (this.img && this.img !== '') {
      this.img_src = await googleApiService.getSignedUrl(this.img);
      return this.img_src;
    } else {
      return null;
    }
  }

  static fromMultipleChoiceOption(question: MultipleChoiceOption) {
    return new MultipleChoiceOption(
      question.id,
      question.question,
      question.text,
      question.correct,
      question.index,
      question.img,
      question.img_file,
      question.img_src,
    );
  }

  static fromServerOption(option: Record<string, any>): MultipleChoiceOption {
    return new MultipleChoiceOption(
      option['id'],
      option['question'],
      option['text'],
      option['correct'],
      option['index'],
      option['img'],
      option['img_file'],
      option['img_src'],
    );
  }

  public toJSON(): Record<string, any> {
    return {
      id: this.id,
      question: this.question,
      text: this.text,
      correct: this.correct,
      index: this.index,
      img_file: this.img_file,
      // img: this.img,
    };
  }
}
